import {Mutable, template as tpl} from "./mutable";
import {SPINNER} from "../../constants";
import {global} from "../../appContext";
import {createErrorMessage} from "../../util/misc";
import {IRouteDefinitionParams} from "../../index";
import PromiseRequest from "../../req/PromiseRequest";
import {CREATING_MESSAGE, ERROR_MESSAGE, REQUEST_MESSAGE} from "../../constants/Language";

export let template: string = tpl;

export class viewModel extends Mutable {

    protected icon = 'fa-sync-template';
    protected label = "Opprett synkroniseringsmal";

    protected override submitRequestMessage: string = CREATING_MESSAGE
    protected override submitSuccessMessage: string = `subject is created|s:((synchronization template))`;
    protected reqSubmit: PromiseRequest = global.getPromiseRequest("createexporttemplate");

    constructor(params: IRouteDefinitionParams) {
        super(params);

        this.data.$original.id = 0;

        this.initRequest()
            .then(() => this.onSuccess())
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))));
    }

}
